/**
 * Console logging utility that only writes to the console in non-production environments.
 * Checks REACT_APP_ENV environment variable - logs are suppressed only when set to 'prod'.
 */

const isProduction = process.env.REACT_APP_ENV === 'prod'
export const logger = {
  log: (...args: any[]) => {
    if (!isProduction) {
      console.log(...args)
    }
  },
  warn: (...args: any[]) => {
    console.warn(...args)
  },
  error: (...args: any[]) => {
    console.error(...args)
  },
  info: (...args: any[]) => {
    if (!isProduction) {
      console.info(...args)
    }
  },
  debug: (...args: any[]) => {
    if (!isProduction) {
      console.debug(...args)
    }
  },
}
